import { render } from "./GaleriaWidget.vue?vue&type=template&id=ce90f790&scoped=true"
import script from "./GaleriaWidget.vue?vue&type=script&lang=js"
export * from "./GaleriaWidget.vue?vue&type=script&lang=js"

import "./GaleriaWidget.vue?vue&type=style&index=0&id=ce90f790&scoped=true&lang=css"

import exportComponent from "/Users/bencorp/Desktop/proyectos/Fitbar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce90f790"]])

export default __exports__